const initVideoOptimization = () => {
  "use strict";

  let videos = [];
  let observer = null;
  // Track why card videos separately
  let whyCardVideos = [];

  function init() {
    videos = Array.from(document.querySelectorAll("video:not(.not-autoplay)"));

    if (videos.length === 0) {
      return;
    }

    createObserver();

    videos.forEach((video) => {
      observer.observe(video);
    });

    // Initialize why card videos
    whyCardVideos = [
      document.getElementById("why-video-1"),
      document.getElementById("why-video-2"),
      document.getElementById("why-video-3"),
    ].filter((video) => video !== null);

    setInterval(checkForNewVideos, 2000);
  }

  // New function to manage why card videos
  function setActiveWhyCard(index) {
    if (!whyCardVideos.length) return;

    // Ensure index is within bounds
    index = Math.max(0, Math.min(whyCardVideos.length - 1, index));

    // Pause all videos first
    whyCardVideos.forEach((video, i) => {
      if (i !== index) {
        pauseVideo(video);
      }
    });

    // Play the active video
    loadVideoIfNeeded(whyCardVideos[index]);
    playVideo(whyCardVideos[index]);

    return whyCardVideos[index];
  }

  // New function to play specific why cards
  function playWhyCards(indices) {
    if (!Array.isArray(indices) || !whyCardVideos.length) return;

    whyCardVideos.forEach((video, index) => {
      if (indices.includes(index)) {
        loadVideoIfNeeded(video);
        playVideo(video);
      } else {
        pauseVideo(video);
      }
    });
  }

  function createObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            loadVideoIfNeeded(video);
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      options
    );
  }

  function loadVideoIfNeeded(video) {
    if (video.dataset.loaded === "true") {
      return; // already lazy-loaded
    }

    const sources = video.querySelectorAll("source[data-src]");
    if (sources.length > 0) {
      sources.forEach((source) => {
        source.src = source.dataset.src;
      });
      video.load();
    } else if (video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }

    video.dataset.loaded = "true";
  }

  function playVideo(video) {
    if (video.paused) {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // playing successfully
          })
          .catch((error) => {
            console.log("Video play failed:", error);
            if (error.name === "NotAllowedError") {
              console.log("Autoplay blocked by browser policy");
            }
          });
      }
    }
  }

  function pauseVideo(video) {
    if (!video.paused) {
      video.pause();
    }
  }

  function checkForNewVideos() {
    const currentVideos = Array.from(
      document.querySelectorAll("video:not(.not-autoplay)")
    );

    currentVideos.forEach((video) => {
      if (!videos.includes(video)) {
        videos.push(video);
        observer.observe(video);
      }
    });
  }

  function cleanup() {
    if (observer) {
      observer.disconnect();
    }
    videos.forEach((video) => {
      pauseVideo(video);
    });
    whyCardVideos.forEach((video) => {
      pauseVideo(video);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("beforeunload", cleanup);

  window.videoAutoplayCleanup = cleanup;

  // Export functions for why cards video management
  window.whyCardVideoManager = {
    setActiveWhyCard,
    playWhyCards,
  };
};

export default initVideoOptimization;
